"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.MARK_ACTIVITY = void 0;
var MARK_ACTIVITY = 'WEB_CHAT/MARK_ACTIVITY';
exports.MARK_ACTIVITY = MARK_ACTIVITY;

function markActivity(_ref, name, value) {
  var activityID = _ref.id;
  return {
    type: MARK_ACTIVITY,
    payload: {
      activityID: activityID,
      name: name,
      value: value
    }
  };
}

var _default = markActivity;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJNQVJLX0FDVElWSVRZIiwibWFya0FjdGl2aXR5IiwibmFtZSIsInZhbHVlIiwiYWN0aXZpdHlJRCIsImlkIiwidHlwZSIsInBheWxvYWQiXSwic291cmNlUm9vdCI6ImNvcmU6Ly8vIiwic291cmNlcyI6WyIuLi8uLi9zcmMvYWN0aW9ucy9tYXJrQWN0aXZpdHkudHMiXSwic291cmNlc0NvbnRlbnQiOlsidHlwZSBNYXJrQWN0aXZpdHlBY3Rpb25UeXBlID0gJ1dFQl9DSEFUL01BUktfQUNUSVZJVFknO1xuXG50eXBlIE1hcmtBY3Rpdml0eUFjdGlvbiA9IHtcbiAgcGF5bG9hZDogeyBhY3Rpdml0eUlEOiBzdHJpbmc7IG5hbWU6IHN0cmluZzsgdmFsdWU6IGFueSB9O1xuICB0eXBlOiBNYXJrQWN0aXZpdHlBY3Rpb25UeXBlO1xufTtcblxuY29uc3QgTUFSS19BQ1RJVklUWTogTWFya0FjdGl2aXR5QWN0aW9uVHlwZSA9ICdXRUJfQ0hBVC9NQVJLX0FDVElWSVRZJztcblxuZnVuY3Rpb24gbWFya0FjdGl2aXR5KHsgaWQ6IGFjdGl2aXR5SUQgfTogeyBpZDogc3RyaW5nIH0sIG5hbWU6IHN0cmluZywgdmFsdWU6IGFueSk6IE1hcmtBY3Rpdml0eUFjdGlvbiB7XG4gIHJldHVybiB7XG4gICAgdHlwZTogTUFSS19BQ1RJVklUWSxcbiAgICBwYXlsb2FkOiB7XG4gICAgICBhY3Rpdml0eUlELFxuICAgICAgbmFtZSxcbiAgICAgIHZhbHVlXG4gICAgfVxuICB9O1xufVxuXG5leHBvcnQgZGVmYXVsdCBtYXJrQWN0aXZpdHk7XG5leHBvcnQgeyBNQVJLX0FDVElWSVRZIH07XG5leHBvcnQgdHlwZSB7IE1hcmtBY3Rpdml0eUFjdGlvbiB9O1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7QUFPQSxJQUFNQSxhQUFxQyxHQUFHLHdCQUE5Qzs7O0FBRUEsU0FBU0MsWUFBVCxPQUEwREMsSUFBMUQsRUFBd0VDLEtBQXhFLEVBQXdHO0VBQUEsSUFBNUVDLFVBQTRFLFFBQWhGQyxFQUFnRjtFQUN0RyxPQUFPO0lBQ0xDLElBQUksRUFBRU4sYUFERDtJQUVMTyxPQUFPLEVBQUU7TUFDUEgsVUFBVSxFQUFWQSxVQURPO01BRVBGLElBQUksRUFBSkEsSUFGTztNQUdQQyxLQUFLLEVBQUxBO0lBSE87RUFGSixDQUFQO0FBUUQ7O2VBRWNGLFkifQ==